<template>
  <div
    class="relative flex flex-col w-full overflow-x-hidden p-10 pt-4 justify-center top-12"
    :class="!isMobilePortrait && 'md:top-0'"
  >
    <div class="text-center">
      <p class="relative text-2xl font-semibold text-primary dark:text-primary-200">
        <span class="relative mr-2">
          <font-awesome-icon icon="fa-solid fa-triangle-exclamation" size="xs" class="left-4 top-2.5 absolute text-danger" />
          <font-awesome-icon icon="fa-regular fa-browser" size="lg" class="dark:text-secondary-200" />
        </span>
        404
      </p>
      <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 dark:text-gray-200 sm:text-7xl">
        Page not found
      </h1>
      <p class="mt-6 text-pretty text-lg font-medium text-gray-500 dark:text-gray-400 sm:text-xl/8">
        Sorry, we couldn’t find the page you’re looking for.
      </p>
      <div class="mt-6 flex items-center justify-center gap-x-6">
        <VButton
          @click="routeToHomePage"
          label="Go Back to Home"
          icon="fa-regular fa-house" icon-first
          size="lg" icon-size="lg"
          color="secondary"
          outlined
          class="fadein mt-7 w-full sm:w-auto"
        />
        <VButton
          @click="routeToSupportPage"
          label="Contact Support"
          icon="fa-regular fa-headset" icon-first
          size="lg" icon-size="lg"
          color="white"
          outlined
          class="fadein mt-7 w-full sm:w-auto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import VButton from "@/components/Buttons/Button/VButton.vue"

export default {
  name: "404Page",
  components: {
    VButton
  },
  computed: {
    ...mapState(["orientation"]),
    isMobile() {
      return /Mobi/i.test(window.navigator.userAgent)
    },
    isMobileLandscape() {
      return this.isMobile && this.orientation.landscape
    },
    isMobilePortrait() {
      return this.isMobile && this.orientation.portrait
    },
  },
  methods: {
    routeToHomePage() {
      this.$router.push("/")
    },
    routeToSupportPage() {
      this.$router.push("/support")
    }
  }
};
</script>

<style scoped>
  /* Image rendering fix */
  img {
    image-rendering: -moz-crisp-edges;         /* Firefox */
    image-rendering:   -o-crisp-edges;         /* Opera */
    image-rendering: -webkit-optimize-contrast;/* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;  /* IE (non-standard property) */
  }
</style>